import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import EnhancedTable from 'lib/designSystem/Table';
import React from 'react';

// Reusable component for all line types with same columns
const LinesTable = ({ data }: { data: any[] }) => (
  <div style={{ overflowX: 'scroll', padding: '8px' }}>
    <EnhancedTable
      dataHeaders={[
        { key: 'userOwnerName', label: 'Ejecutivo' },
        // {
        //   key: 'totalRealWallet',
        //   label: 'Total colocado',
        //   type: 'money',
        // },
        // {
        //   key: 'totalRealWalletNet',
        //   label: 'Total colocado neto',
        //   type: 'money',
        // },
        { key: 'totalIncome', label: 'Ingreso total', type: 'money' },
        { key: 'totalPriceIncome', label: 'Interés devengado', type: 'money' },
        { key: 'totalArrearIncome', label: 'Interés mora', type: 'money' },
        { key: 'totalComissionIncome', label: 'Monto comisión', type: 'money' },
        { key: 'totalExpensesIncome', label: 'Gastos', type: 'money' },
        { key: 'totalExtensionIncome', label: 'Prórroga', type: 'money' },
        { key: 'totalOtherIncome', label: 'Otros', type: 'money' },
      ]}
      data={data}
      exportToFile="xlsx"
      rowsPerPageDefault={25}
      finalSumRow
    />
  </div>
);

const ExecutiveDialog = (props: any) => {
  const {
    linesByExecutive,
    openDialog,
    handleCloseDialog,
    startTitle,
    endTitle,
  } = props;
  // Filter out disabled tabs

  return (
    <Dialog
      open={openDialog}
      onClose={handleCloseDialog}
      maxWidth="xl"
      fullWidth
    >
      <DialogTitle>
        Ingresos por ejecutivo {startTitle} - {endTitle}
      </DialogTitle>
      <DialogContent>
        {linesByExecutive.length > 0 ? (
          <LinesTable data={linesByExecutive} />
        ) : (
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ padding: '16px' }}
          >
            No hay datos disponibles para mostrar
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ExecutiveDialog;
